function availabilityNotification() {

    const notifyBtn = document.getElementById('notify-availability-btn');
    const popup = document.getElementById('notify-availability-popup');
    const closeBtn = document.querySelector('.popup-close');
    const form = document.getElementById('notify-availability-form');
    const successMessage = document.getElementById('notify-success-message');

    if (notifyBtn) {
        notifyBtn.addEventListener('click', function () {
            const productId = this.getAttribute('data-product-id');
            const productTitle = this.getAttribute('data-product-title');

            document.getElementById('notify-product-id').value = productId;
            document.getElementById('notify-product-title').value = productTitle;
            popup.style.display = 'block';
        });
    }

    if (closeBtn) {
        closeBtn.addEventListener('click', function () {
            popup.style.display = 'none';
            form.style.display = 'block';
            successMessage.style.display = 'none';
        });
    }

    window.addEventListener('click', function (event) {
        if (event.target === popup) {
            popup.style.display = 'none';
            form.style.display = 'block';
            successMessage.style.display = 'none';
        }
    });

    if (form) {
        form.addEventListener('submit', function (e) {
            e.preventDefault();

            const email = document.getElementById('notify-email').value;
            const productTitle = document.getElementById('notify-product-title').value;
            const name = document.getElementById('notify-name').value;

            // Send AJAX request
            fetch(ajax_object.ajax_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    action: 'notify_availability_signup',
                    email: email,
                    name: name,
                    product_title: productTitle,
                    nonce: ajax_object.nonce
                })
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        form.style.display = 'none';
                        successMessage.style.display = 'block';

                        setTimeout(() => {
                            popup.style.display = 'none';
                            form.style.display = 'block';
                            successMessage.style.display = 'none';
                            document.getElementById('notify-email').value = '';
                        }, 3000);
                    } else {
                        alert('Error: ' + data.data.message);
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                    alert('An error occurred. Please try again.');
                });
        });
    }
}

export default {availabilityNotification};